import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import Markdown from 'react-markdown'
import SectionTitle from '../../shared/components/SectionTitle'

import styles from './styles.module.css'
import AskQuote from '../../shared/components/AskQuote'

import {
  isLoadingServicesList,
  getServiceDetails,
} from '../../shared/state/services/selectors'
import { loadServices } from '../../shared/state/services/actions'

class ServiceDetails extends Component {
  componentDidMount() {
    this.props.dispatch(loadServices())
  }

  render() {
    const {
      service: { name, text, photo: { url: photoUrl } = {} } = {},
    } = this.props

    return (
      <div className={styles.main}>
        <div className={styles.serviceHeader}>
          <img src={photoUrl} />
        </div>
        <div className={styles.serviceDetailsWrapper}>
          <div className={styles.serviceDetails}>
            <Link to="/servicos">
              <div className={styles.backButton}>{'< Voltar Atrás'}</div>
            </Link>
            <SectionTitle title={name} center={false} />

            <div className={styles.serviceDescription}>
              <Markdown source={text} />
            </div>
          </div>

          <div className={styles.askQuote}>
            <AskQuote serviceName={name} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = () => {
  return (state, { match: { params: { serviceId } = {} } }) => ({
    isLoadingServices: isLoadingServicesList(state),
    service: getServiceDetails(state, { serviceId }),
  })
}

export default connect(mapStateToProps)(ServiceDetails)
